import { Button } from '@radix-ui/themes';
import { MachineUnavailableButton } from 'components/machine/buttons/unavailable';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { CalibrateProc } from 'lib_ts/enums/machine.enums';
import { RadixBtnSize } from 'lib_ts/enums/radix-ui';
import { useContext, useMemo } from 'react';

const COMPONENT_NAME = 'ProjectorToggleButton';

interface IProps {
  disabled?: boolean;

  mode: 'outline' | 'rulers';

  /** applied to the button tag */
  className?: string;

  size?: RadixBtnSize;
}

export const MachineProjectorToggleButton = (props: IProps) => {
  const { isActive, calibrating, calibrate } = useContext(MachineContext);

  const label = useMemo(() => {
    switch (props.mode) {
      case 'outline': {
        return t('common.toggle-outline');
      }

      case 'rulers': {
        return t('common.toggle-rulers');
      }

      default: {
        return 'UNKNOWN';
      }
    }
  }, [props.mode]);

  if (!isActive) {
    return (
      <MachineUnavailableButton size={props.size} className={props.className} />
    );
  }

  return (
    <Button
      size={props.size}
      disabled={calibrating || !!props.disabled}
      className={props.className}
      onClick={() => {
        switch (props.mode) {
          case 'outline': {
            calibrate([CalibrateProc.ProjectorOutline], COMPONENT_NAME);
            break;
          }
          case 'rulers': {
            calibrate([CalibrateProc.ProjectorRulers], COMPONENT_NAME);
            break;
          }
          default: {
            break;
          }
        }
      }}
    >
      {label}
    </Button>
  );
};
